import TableChartSidebar from 'components/Table/TableChartSidebar';
import { PitcherReportChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';
import { ChartConfigProps } from 'utilities/chartIdToComponent';

const PitchingStatsChartSidebar = (props: ChartConfigProps<TableChartConfigDto, PitcherReportChartConfigDto>) => {
  return <TableChartSidebar chartId='PitchingStatsChart' configKey='pitchingStatsChartConfig' {...props} />;
};

export default PitchingStatsChartSidebar;
